import React, { useState } from "react";
import { Grid, GridRow, Radio, GridColumn } from "semantic-ui-react";
import 'semantic-ui-css/semantic.min.css';
import "../App.css";

function Navbar({ onSelectFilters }) {
  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleCheckboxChange = (filter) => {
    const category = getCategory(filter);
    const deselectedFilters = selectedFilters.filter(
      (item) => getCategory(item) !== category
    );
    const updatedFilters = [...deselectedFilters, filter];
    setSelectedFilters(updatedFilters);
    onSelectFilters(updatedFilters); 
  };

  const getCategory = (filter) => {
    if (["classic drink", "signature drink"].includes(filter)) {
      return "drinkType";
    } else if (["blanco", "reposado","cristalino"].includes(filter)) {
      return "tequilaType";
    } else if (["easy", "medium", "hard"].includes(filter)) {
      return "complexity";
    }
    return "";
  };

  return (
    <Grid stackable divided padded>

      <GridRow stretched columns={2} className="nav-content-filter" centered>

        <GridColumn verticalAlign="top" width={16} textAlign="center" only="mobile">
            <h6>Find your cocktail</h6>
        </GridColumn>

        <GridColumn verticalAlign="top" computer={3} tablet={4} textAlign="left" className="tequila-filter-column">

            {/*
            <label>
              <input
                type="checkbox"
                checked={selectedFilters.includes("blanco")}
                onChange={() => handleCheckboxChange("blanco")}
              />
              Blanco
            </label>
            <label>
              <input
                type="checkbox"
                checked={selectedFilters.includes("reposado")}
                onChange={() => handleCheckboxChange("reposado")}
              />
              Reposado
            </label>
            */}
          <h5>Tequila</h5>            

          <Radio
            label={<label>Blanco</label>}
            checked={selectedFilters.includes("blanco")}
            onChange={() => handleCheckboxChange("blanco")}
          />

          <Radio
            label={<label>Reposado</label>}
            checked={selectedFilters.includes("reposado")}
            onChange={() => handleCheckboxChange("reposado")}
          />

          <Radio
            label={<label>Cristalino</label>}
            checked={selectedFilters.includes("cristalino")}
            onChange={() => handleCheckboxChange("cristalino")}
          />
        </GridColumn>

        <GridColumn verticalAlign="top" computer={3} tablet={4} textAlign="left">
        {/*
          <label>
            <input
              type="checkbox"
              checked={selectedFilters.includes("classic drink")}
              onChange={() => handleCheckboxChange("classic drink")}
            />
            Classic Drink
          </label>
          <label>
            <input
              type="checkbox"
              checked={selectedFilters.includes("signature drink")}
              onChange={() => handleCheckboxChange("signature drink")}
            />
            Signature Drink
          </label>
          */}
          <h5>Type</h5>
          <Radio
            label={<label>Classic Drink</label>}
            checked={selectedFilters.includes("classic drink")}
            onChange={() => handleCheckboxChange("classic drink")}
          />
          <Radio
            label={<label>Signature Drink</label>}
            checked={selectedFilters.includes("signature drink")}
            onChange={() => handleCheckboxChange("signature drink")}
          />
          </GridColumn>

          <GridColumn width={16} textAlign="center">
              <a className="reset-link" href="/">
                  Reset filters
              </a>
          </GridColumn>

        </GridRow>

      </Grid>

  );
}

export default Navbar;